













import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'SimpleTable',
	props: {
		tableKey: { type: String, default: '0' },
		rowKey: { type: String, default: '0' },
		height: { type: String, default: '100%' },
		loading: { type: Boolean },
		table: { type: Array, default: ():[] => [] },
		showHeader: { type: Boolean, default: true },
		defaultSort: { type: Object },
	},
	computed: {
		noDataText(): string {
			return this.Localize('TableMsgNoData');
		},
	},
	methods: {
		handleRowClick(row: any, column: { type: string }) {
			this.$emit('update:selectedRow', row);
		},
	},
});
